import { useCallback } from 'react';
import { dispatcher } from 'dispatcher';
import { htcmdService } from 'js/services/htcmd.service';
import { EVENT_SHOW_LOGIN_POPUP } from './buzz/constants';

export const useLoginPopup = () => useCallback(popupData => {
    if (htcmdService.isEnabled) {
        htcmdService.sendMessage('//openLogin');
        return;
    }

    dispatcher.dispatch(EVENT_SHOW_LOGIN_POPUP, popupData);
}, []);
